import {PageRequest, PageResult} from '../../models/PageableModel';
import {getHeaders, urls} from './urls';
import {globalUrlDev} from './servers';
import axios from 'axios';
import {FilterModel, MainModel} from '../../models/GenericModel';
import {DwnlUplDocument} from '../../models/Document';

export abstract class BaseService<M extends MainModel, F extends FilterModel> {

  protected mainUrl: string;

  constructor(private url: String) {
    this.mainUrl = globalUrlDev + url;
  }

  async list(pageModel?: PageRequest, filter?: F, urlSpecifications: string = ''): Promise<PageResult<M>> {
    const endpoint = this.mainUrl + urls.list + urlSpecifications;
    const params = pageModel ? pageModel : {};
    if (filter == null) {
      const response = await axios.get<PageResult<M>>(endpoint, {params: params, data: {}, headers: getHeaders()});
      return response.data;
    } else {
      const body = JSON.stringify(filter);
      const response = await axios.post<PageResult<M>>(endpoint, body, {params: params, headers: getHeaders()});
      return response.data;
    }
  }

  async simpleList(filter?: F, urlSpecifications: string = ''): Promise<M[]> {
    const page = await this.list(null, filter);
    return page.content;
  }

  async fetchById(id: number): Promise<M> {
    const endpoint = this.mainUrl + id;
    const response = await axios.get<M>(endpoint, {data: {}, headers: getHeaders()});
    return response.data;
  }

  async create(model: any): Promise<M> {
    const endpoint = this.mainUrl;
    const body = JSON.stringify(model);
    const response = await axios.post<M>(endpoint, body, {headers: getHeaders()});
    return response.data;
  }

  async update(model: any): Promise<M> {
    const endpoint = this.mainUrl;
    const body = JSON.stringify(model);
    const response = await axios.put<M>(endpoint, body, {headers: getHeaders()});
    return response.data;
  }

  async delete(id: number): Promise<any> {
    const endpoint = this.mainUrl + id;
    return axios.delete(endpoint, {data: {}, headers: getHeaders()});
  }

  async customDelete(data: M): Promise<any> {
    const endpoint = this.mainUrl;
    return axios.delete(endpoint, {data: data, headers: getHeaders()});
  }

  async downloadXls(filter?: F): Promise<any> {
    const endpoint = this.mainUrl + urls.downloadXls;
    return filter ? axios.post<DwnlUplDocument>(endpoint, JSON.stringify(filter), {responseType: 'blob', headers: getHeaders()})
      : axios.get<DwnlUplDocument>(endpoint, {data: {}, responseType: 'blob', headers: getHeaders() });
  }

  async downloadXlsFromSession(id: number): Promise<any> {
    const endpoint = this.mainUrl + urls.downloadXls;
    return await axios.get<M>(endpoint + 'session/' + id, {data: {}, responseType: 'blob', headers: getHeaders()});
  }

  async downloadXlsFromPlanning(id: number): Promise<any> {
    const endpoint = this.mainUrl + urls.downloadXls;
    return await axios.get<M>(endpoint + 'planning/' + id, {data: {}, responseType: 'blob', headers: getHeaders()});
  }
}
